import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.Delete.IRequest;
type Response = Api.Core.ProductDocument.Delete.IResponse;
type Headers = Api.Core.ProductDocument.Delete.IHeaders;
const url = '/api/ProductManagement/ProductDocument/:productId/:documentId';
export default async function productDocumentDeleteApi(params: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
